export default __webpack_public_path__ + "static/sarsons-f37bd473fde418172e26c5c805789328.jpeg";